export type JobQuestion = { key: string; question: string; help: string | null; answers: Array<{ value: string; label: string }>;
  /** Asked with a Yes, where a rule in the state counts the notice's days from when it happened. */
  dateQuestion: string | null };
/** Each answer is a select named `answer.<question key>`; `projectInput` gathers them into the job's answers. */
export const answerField = 'answer.';
/** The job's facts that decide which questions its state's rules ask. */
export const jobFields = ['stateCode', 'classification', 'claimantRole', 'contractingTier', 'projectUse'] as const;
/** The date a Yes answer's event happened, an input named `answerDate.<question key>`. */
export const answerDateField = 'answerDate.';
